import React from 'react';
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { Question } from '../../../types/questionnaire';
import { BaseQuestionRenderer } from './BaseQuestionRenderer';

interface RadioGroupRendererProps {
  question: Question;
  value: any;
  onChange: (questionName: string, value: any) => void;
}

export const RadioGroupRenderer: React.FC<RadioGroupRendererProps> = ({ question, value, onChange }) => {
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(question.name, event.target.value);
  };

  return (
    <BaseQuestionRenderer question={question}>
      <FormControl component="fieldset" fullWidth>
        <RadioGroup value={value} onChange={handleRadioChange}>
          {question.options.map(option => (
            <FormControlLabel
              key={option.id}
              value={option.value}
              control={<Radio />}
              label={option.caption}
              // checked={option.selected} // This will now be handled by the RadioGroup's value prop
            />
          ))}
        </RadioGroup>
      </FormControl>
    </BaseQuestionRenderer>
  );
};
